export interface BracketFieldRange {
  from: number;
  to: number;
}

export const BRACKET_FIELD_OPEN = "[";
export const BRACKET_FIELD_CLOSE = "]";

export function findBracketFields(text: string): BracketFieldRange[] {
  const fields: BracketFieldRange[] = [];
  let openIndex = -1;

  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];

    if (character === BRACKET_FIELD_OPEN) {
      openIndex = index;
    } else if (character === BRACKET_FIELD_CLOSE && openIndex >= 0) {
      if (index > openIndex + 1) fields.push({ from: openIndex, to: index + 1 });

      openIndex = -1;
    }
  }

  return fields;
}
